/*
  assets/m52-cart-widget.js — v2 (mini-panier en grille « catalogue » + frise des cadeaux)
  Mini-panier compact (remplace le tiroir du thème) + améliorations fiche produit.
  Config : window.M52Cart (snippets/m52-cart-widget.liquid).
*/
(function () {
  if (window.__m52CartLoaded) return;
  window.__m52CartLoaded = true;

  var C = window.M52Cart || {};
  var T = C.t || {};
  var ROOT = C.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  /* ================= Utilitaires ================= */
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(C.locale === 'fr' ? 'fr-FR' : 'en-GB', {
        style: 'currency', currency: C.currency || 'EUR'
      }).format(v);
    } catch (e) { return v.toFixed(2) + ' €'; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, data: d }; });
    });
  }

  /* ================= Mini-panier ================= */
  var el = {}, isOpen = false, busy = false;

  function build() {
    if (el.panel) return;
    var ov = document.createElement('div');
    ov.className = 'm52c-overlay';
    var p = document.createElement('aside');
    p.className = 'm52c';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
    p.setAttribute('aria-label', T.title || 'Cart');
    p.innerHTML =
      '<div class="m52c__head"><h2 class="m52c__title">' + esc(T.title) + '<span class="m52c__count"></span></h2>' +
      '<button type="button" class="m52c__close" aria-label="' + esc(T.close) + '">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="m52c__added"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a8a3a" stroke-width="2.4"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + esc(T.added) + '</span></div>' +
      '<div class="m52c__fsb"></div>' +
      '<div class="m52c__giftpick"></div>' +
      '<div class="m52c__list"></div>' +
      '<div class="m52c__foot">' +
      '<div class="m52c__row"><span>' + esc(T.subtotal) + '</span><span class="m52c__total"></span></div>' +
      '<p class="m52c__note">' + esc(T.taxes) + '</p>' +
      '<a class="m52c__checkout" href="' + ROOT + 'checkout">' + esc(T.checkout) + '</a>' +
      '<div class="m52c__links"><button type="button" class="m52c__keep">' + esc(T.keepShopping) + '</button>' +
      '<a href="' + esc(C.cartUrl || '/cart') + '" data-m52c-native>' + esc(T.viewCart) + '</a></div>' +
      '</div>';
    document.body.appendChild(ov);
    document.body.appendChild(p);
    el = {
      overlay: ov, panel: p,
      list: p.querySelector('.m52c__list'),
      count: p.querySelector('.m52c__count'),
      total: p.querySelector('.m52c__total'),
      added: p.querySelector('.m52c__added'),
      foot: p.querySelector('.m52c__foot'),
      fsb: p.querySelector('.m52c__fsb'),
      giftpick: p.querySelector('.m52c__giftpick')
    };
    ov.addEventListener('click', close);
    p.querySelector('.m52c__close').addEventListener('click', close);
    p.querySelector('.m52c__keep').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    el.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || busy) return;
      var row = b.closest('.m52c__card');
      var key = row.getAttribute('data-key');
      var q = parseInt(row.getAttribute('data-qty'), 10) || 0;
      var act = b.getAttribute('data-act');
      if (act === 'plus') change(key, q + 1);
      else if (act === 'minus') change(key, Math.max(0, q - 1));
      else if (act === 'remove') change(key, 0);
    });
  }

  function open(highlightKey) {
    build();
    el.added.classList.toggle('is-on', !!highlightKey);
    el.overlay.classList.add('is-open');
    el.panel.classList.add('is-open');
    document.documentElement.classList.add('m52c-lock');
    isOpen = true;
    return refresh(highlightKey);
  }

  function close() {
    if (!el.panel) return;
    el.overlay.classList.remove('is-open');
    el.panel.classList.remove('is-open');
    document.documentElement.classList.remove('m52c-lock');
    isOpen = false;
  }

  function refresh(highlightKey) {
    return getJSON(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { render(r.data, highlightKey); return r.data; })
      .catch(function () {});
  }

  function render(cart, highlightKey) {
    build();
    if (!cart) return;
    updateCounters(cart.item_count);
    el.count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    el.total.textContent = money(cart.total_price);
    el.foot.style.display = cart.item_count ? '' : 'none';

    renderTiers(cart);
    renderGiftPick(cart);

    if (!cart.items || !cart.items.length) {
      el.list.className = 'm52c__list';
      el.list.innerHTML = '<p class="m52c__empty">' + esc(T.empty) + '</p>';
      return;
    }
    /* Catalogue : grille de vignettes, 3 par ligne (2 s'il n'y a que 1-2 articles) */
    el.list.className = 'm52c__list m52c__grid' + (cart.items.length <= 2 ? ' m52c__grid--2' : '');
    var html = '';
    cart.items.forEach(function (it) {
      var gift = isGiftItem(it);
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !it.properties[k]) return;
          props += ' · ' + esc(it.properties[k]);
        });
      }
      var name = String(it.product_title || '').replace(/\s*[—–-]\s*(cadeau offert|free gift)\s*$/i, '');
      var compare = !gift && it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var price = gift || it.final_line_price === 0 ? esc(T.free) : money(it.final_line_price);
      html +=
        '<div class="m52c__card' + (gift ? ' is-gift' : '') + (it.key === highlightKey ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
          '<a class="m52c__cimg" href="' + esc(gift ? '#' : it.url) + '"' + (gift ? ' tabindex="-1"' : '') + '>' +
            (it.image ? '<img src="' + esc(imgUrl(it.image, 300)) + '" alt="" loading="lazy">' : '') +
            (gift ? '<span class="m52c__badge">' + esc(T.giftBadge) + '</span>' : '') +
            (!gift && it.quantity > 1 ? '<span class="m52c__qbadge">×' + it.quantity + '</span>' : '') +
          '</a>' +
          (gift ? '' : '<button type="button" class="m52c__x" data-act="remove" aria-label="' + esc(T.remove) + '">' +
            '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 6l12 12M18 6L6 18"/></svg></button>') +
          '<span class="m52c__cname">' + esc(name) + '</span>' +
          '<span class="m52c__cmeta">' + esc(variant) + props + '</span>' +
          '<span class="m52c__cprice">' + compare + '<b>' + price + '</b></span>' +
          (gift ? '' : '<span class="m52c__cqty"><button type="button" data-act="minus" aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-act="plus" aria-label="+">+</button></span>') +
        '</div>';
    });
    el.list.innerHTML = html;
    if (highlightKey) {
      var n = el.list.querySelector('.is-new');
      if (n && n.scrollIntoView) n.scrollIntoView({ block: 'nearest' });
    }
  }

  /* ---- Cadeaux & frise des paliers (150 € livraison / 210 € spinner / 320 € boxer) ---- */
  var GIFT_HANDLES = ['cadeau-handspinner', 'cadeau-boxer'];
  function isGiftItem(it) {
    return GIFT_HANDLES.indexOf(it.handle) >= 0 || (it.final_line_price === 0 && it.original_line_price === 0);
  }
  function eligibleTotal(cart) {
    var q = 0;
    (cart.items || []).forEach(function (it) { if (!isGiftItem(it)) q += it.final_line_price; });
    return q;
  }
  function tiers() {
    return (C.tiers || []).filter(function (t) { return t && t.a > 0; })
      .sort(function (a, b) { return a.a - b.a; });
  }

  function renderTiers(cart) {
    var list = tiers();
    if (!el.fsb) return;
    if (!list.length || !cart.item_count) { el.fsb.style.display = 'none'; return; }
    el.fsb.style.display = '';
    var total = eligibleTotal(cart);
    var max = list[list.length - 1].a;
    var next = null, lastUnlocked = null;
    list.forEach(function (t) {
      if (total >= t.a) lastUnlocked = t;
      else if (!next) next = t;
    });
    var msg;
    if (!next) msg = (C.msgUnlocked || '[palier]').replace('[palier]', lastUnlocked ? lastUnlocked.u : '');
    else msg = (C.msgProgress || '[montant] → [palier]').replace('[montant]', money(next.a - total)).replace('[palier]', next.l);
    var pct = Math.max(0, Math.min(100, total / max * 100));

    var h = '<p class="m52c__fsb-msg' + (next ? '' : ' is-done') + '">' +
      (next ? '' : '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1f8f55" stroke-width="2.6"><path d="M20 6L9 17l-5-5"/></svg>') +
      '<span>' + esc(msg) + '</span></p>' +
      '<div class="m52c__track"><div class="m52c__fill" style="width:' + pct.toFixed(1) + '%"></div>';
    if (list.length > 1) list.forEach(function (t) {
      h += '<span class="m52c__dot' + (total >= t.a ? ' is-on' : '') + '" style="left:' + (t.a / max * 100).toFixed(2) + '%"></span>';
    });
    h += '</div>';
    if (list.length > 1) {
      h += '<div class="m52c__tiers" style="grid-template-columns:repeat(' + list.length + ',minmax(0,1fr))">';
      list.forEach(function (t) {
        var img = (C.tierImages || {})[t.a];
        h += '<div class="m52c__tier' + (total >= t.a ? ' is-on' : '') + '">' +
          (img ? '<span class="m52c__tier-img"><img src="' + esc(img) + '" alt=""></span>'
               : '<span class="m52c__tier-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1.5" y="5" width="13" height="11" rx="1"/><path d="M14.5 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg></span>') +
          '<span class="m52c__tier-amt">' + esc(moneyShort(t.a)) + '</span>' +
          '<span class="m52c__tier-lbl">' + esc(t.l) + '</span></div>';
      });
      h += '</div>';
    }
    if (C.fsbNote) h += '<p class="m52c__fsb-note">' + esc(C.fsbNote) + '</p>';
    el.fsb.innerHTML = h;
  }

  function moneyShort(cents) {
    var v = cents / 100;
    return (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  /* Boxer offert débloqué mais pas encore dans le panier : choix de la taille.
     Les boutons [data-m52-boxer] sont gérés par assets/m52-gifts.js (ajout au panier). */
  function renderGiftPick(cart) {
    if (!el.giftpick) return;
    var boxerAt = C.boxerAt || 32000;
    var hasBoxer = (cart.items || []).some(function (it) { return it.handle === 'cadeau-boxer'; });
    var show = C.boxerSizes && C.boxerSizes.length && eligibleTotal(cart) >= boxerAt && !hasBoxer;
    if (!show) { el.giftpick.innerHTML = ''; el.giftpick.style.display = 'none'; return; }
    el.giftpick.style.display = '';
    el.giftpick.innerHTML = '<span class="m52c__gp-t">🎁 ' + esc(T.boxerPick) + '</span><span class="m52c__gp-s">' +
      C.boxerSizes.map(function (s) { return '<button type="button" data-m52-boxer="' + esc(s) + '">' + esc(s) + '</button>'; }).join('') +
      '</span>';
  }

  function change(key, qty) {
    busy = true;
    el.panel.classList.add('is-busy');
    getJSON(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (r.ok) { render(r.data); announce(r.data); }
      else refresh();
    }).finally(function () {
      busy = false;
      el.panel.classList.remove('is-busy');
    });
  }

  function updateCounters(n) {
    document.querySelectorAll('[data-cart-count], #CartCount, .cart-count, .cart-count-bubble span').forEach(function (c) {
      if (!c.closest('.m52c')) c.textContent = n;
    });
  }

  /* Prévient le reste du thème (m52-gifts.js ajoute/retire les cadeaux sur « cart:updated ») */
  var announcing = false;
  function announce(cart) {
    announcing = true;
    try {
      document.dispatchEvent(new CustomEvent('m52:cart-updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {}
    announcing = false;
  }

  /* Quand un autre script modifie le panier (ex. cadeau ajouté), on rafraîchit le mini-panier ouvert */
  var extTimer = null;
  document.addEventListener('cart:updated', function (e) {
    if (announcing || !isOpen) return;
    var d = e.detail;
    clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      if (d && d.items && typeof d.item_count === 'number') render(d);
      else refresh();
    }, 60);
  });

  /* ---- Ajout au panier sans changer de page (formulaires produit) ---- */
  function isAddForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (form.hasAttribute('data-m52c-native')) return false;
    var a = form.getAttribute('action') || '';
    return /\/cart\/add(\.js)?\/?(\?|$)/.test(a);
  }

  document.addEventListener('submit', function (e) {
    if (!C.enabled) return;
    var form = e.target;
    if (!isAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[type="submit"], .product-info__cart-btn');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    getJSON(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) {
        var msg = (r.data && (r.data.description || r.data.message)) || T.error;
        flashButton(btn, msg);
        return;
      }
      var item = r.data && r.data.items ? r.data.items[0] : r.data;
      open(item && item.key).then(announce);
    }).catch(function () {
      flashButton(btn, T.error);
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    });
  }, true);

  function flashButton(btn, msg) {
    if (!btn) { alertInline(msg); return; }
    var old = btn.textContent;
    btn.textContent = msg;
    setTimeout(function () { btn.textContent = old; }, 2200);
  }
  function alertInline(msg) { console.warn('[M52 cart]', msg); }

  /* Tailles rapides des cartes produit (product-catalog.js envoie « cart:refresh » avec l'article ajouté) */
  document.addEventListener('cart:refresh', function (e) {
    if (!C.enabled) return;
    var d = e.detail;
    if (d && (d.variant_id || d.key || (d.items && d.items.length))) {
      var key = d.key || (d.items && d.items[0] && d.items[0].key);
      open(key);
    }
  });

  /* L'icône panier ouvre le mini-panier au lieu de l'ancien tiroir / de la page */
  document.addEventListener('click', function (e) {
    if (!C.enabled || !C.iconOpens) return;
    var t = e.target.closest('a[href], button[data-cart-drawer-toggle], .js-cart-toggle');
    if (!t || t.closest('.m52c') || t.hasAttribute('data-m52c-native')) return;
    if (t.tagName === 'A') {
      var href = t.getAttribute('href') || '';
      var path;
      try { path = new URL(href, location.href).pathname; } catch (err) { return; }
      if (!/\/cart\/?$/.test(path)) return;
      if (/\/cart\/?$/.test(location.pathname)) return; /* déjà sur la page panier */
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* Empêche l'ancien tiroir du thème de s'ouvrir par-dessus */
  function neutraliseThemeDrawer() {
    if (!C.enabled) return;
    var s = document.createElement('style');
    s.textContent = '#CartDrawer,#CartDrawerOverlay{display:none!important}';
    document.head.appendChild(s);
  }

  /* ================= Fiche produit ================= */
  function pdp() {
    if (!C.isProduct) return;
    document.body.classList.add('m52-pdp');
    if (C.pdpHidePrice) stripButtonPrice();
    styleSizeGuide();
    if (C.pdpMoveBtn) moveButton();
    if (C.pdpThumbs) thumbs();
    /* le guide des tailles peut être injecté plus tard par un autre script */
    setTimeout(function () { styleSizeGuide(); if (C.pdpMoveBtn) moveButton(); }, 900);
  }

  function stripButtonPrice() {
    document.querySelectorAll('.product-info__cart-btn').forEach(function (b) {
      var fix = function () {
        var txt = b.textContent;
        var i = txt.indexOf(' — ');
        if (i === -1) i = txt.indexOf(' - €');
        if (i !== -1) b.textContent = txt.slice(0, i).trim();
      };
      fix();
      new MutationObserver(fix).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  var SG_RE = /^\s*(size\s*guide|size\s*chart|guide\s*des\s*tailles|guide\s*de\s*tailles)\s*$/i;
  function findSizeGuide() {
    var scope = document.querySelector('.product-info') || document;
    var list = scope.querySelectorAll('button, a, [role="button"], [class*="size-guide"], [class*="sizeguide"], [class*="size-chart"]');
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (n.closest('.m52c')) continue;
      if (/^(BUTTON|A)$/.test(n.tagName) || n.getAttribute('role') === 'button') {
        if (SG_RE.test(n.textContent || '')) return n;
      }
    }
    return null;
  }
  function styleSizeGuide() {
    var sg = findSizeGuide();
    if (sg) sg.classList.add('m52-sg-link');
    return sg;
  }

  function moveButton() {
    var btn = document.querySelector('#AddToCartForm .product-info__cart-btn');
    if (!btn || btn.getAttribute('data-m52-moved') === '2') return;
    var container = btn.parentElement;
    var opts = document.querySelectorAll('#AddToCartForm .product-options');
    var anchor = opts.length ? opts[opts.length - 1] : null;
    var sg = findSizeGuide();
    if (sg && anchor && (anchor.compareDocumentPosition(sg) & Node.DOCUMENT_POSITION_FOLLOWING)) anchor = sg;
    if (!anchor) {
      anchor = document.querySelector('#AddToCartForm .product-price-mobile');
    }
    if (!anchor) return;
    var top = anchor;
    while (top && top.parentElement !== container) top = top.parentElement;
    if (!top) return;
    if (top.nextElementSibling !== btn) container.insertBefore(btn, top.nextSibling);
    btn.setAttribute('data-m52-moved', sg ? '2' : '1');
  }

  function thumbs() {
    var gallery = document.getElementById('gallery');
    if (!gallery || gallery.getAttribute('data-m52-thumbs')) return;
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__item-img, .product__item-video'));
    var imgs = items.filter(function (i) { return i.tagName === 'IMG'; });
    if (imgs.length < 2) return;
    gallery.setAttribute('data-m52-thumbs', '1');

    var strip = document.createElement('div');
    strip.className = 'm52-thumbs';
    items.forEach(function (it, index) {
      if (it.tagName !== 'IMG') return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'm52-thumb';
      b.setAttribute('data-index', index);
      b.setAttribute('aria-label', 'Photo ' + (index + 1));
      b.innerHTML = '<img src="' + esc(imgUrl(it.getAttribute('src'), 160)) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () {
        var dots = document.querySelectorAll('#nav-dots .nav-dot');
        if (dots[index]) dots[index].click();
      });
      strip.appendChild(b);
    });

    var nav = document.getElementById('image-navigation');
    var after = nav && nav.previousElementSibling === gallery ? nav : gallery;
    after.parentNode.insertBefore(strip, after.nextSibling);
    document.body.classList.add('m52-has-thumbs');

    function sync() {
      var active = items.findIndex(function (i) { return i.classList.contains('active'); });
      strip.querySelectorAll('.m52-thumb').forEach(function (t) {
        var on = parseInt(t.getAttribute('data-index'), 10) === active;
        t.classList.toggle('is-active', on);
        if (on && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }
    var mo = new MutationObserver(sync);
    items.forEach(function (i) { mo.observe(i, { attributes: true, attributeFilter: ['class'] }); });
    sync();
  }

  /* Menu mobile (tiroir gauche) : un tap sur le fond assombri le ferme */
  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('mobile-menu-open')) return;
    if (e.target !== document.body && e.target !== document.documentElement) return;
    var c = document.querySelector('.header-menu [data-menu-close]');
    if (c) c.click();
  });

  /* ================= Init ================= */
  function init() {
    neutraliseThemeDrawer();
    build();
    pdp();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }

  window.M52CartWidget = { open: open, close: close, refresh: refresh };
})();
